export default class NotificationService {
  constructor(Notification, $http, appConfig) {
    "ngInject";

    this.Notification = Notification;
    this.$http = $http;
    this.appConfig = appConfig;
  }

  showEnquiryNotification(scope, templateId) {
    this.Notification.info({
      positionY: 'bottom',
      delay: 30 * 1000,
      replaceMessage: false,
      templateUrl: `templates/notification/${templateId}`,
      scope: scope
    });
  }

  sendFinanceCreatedNotification(financeId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/notification/notifyfinancecreated/${financeId}`);
  }  
}



// WEBPACK FOOTER //
// ./client/app/common/services/notificationService.js